// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MAGAZINE_ARCHIVE_PAGE_LOADING() {
      return {
        isLoading: true,
        magazineArchivePage: action.magazineArchivePage
      };
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.homepage
      };
    },
    MAGAZINE_ARCHIVE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchivePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
